"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.OrderAlgorithmStrategy = void 0;
var OrderAlgorithmStrategy;
exports.OrderAlgorithmStrategy = OrderAlgorithmStrategy;
(function (OrderAlgorithmStrategy) {
  OrderAlgorithmStrategy["FOE"] = "FOE";
  OrderAlgorithmStrategy["ICE"] = "ICE";
  OrderAlgorithmStrategy["PEGGER"] = "PEGGER";
  OrderAlgorithmStrategy["POV"] = "POV";
  OrderAlgorithmStrategy["PTWAP"] = "PTWAP";
  OrderAlgorithmStrategy["PTWAPSE"] = "PTWAPSE";
  OrderAlgorithmStrategy["PVWAP"] = "PVWAP";
  OrderAlgorithmStrategy["SOR"] = "SOR";
  OrderAlgorithmStrategy["SPREAD"] = "SPREAD";
  OrderAlgorithmStrategy["SVWAP"] = "SVWAP";
  OrderAlgorithmStrategy["TWAP"] = "TWAP";
  OrderAlgorithmStrategy["VWAP"] = "VWAP";
  OrderAlgorithmStrategy["RFS"] = "RFS";
  OrderAlgorithmStrategy["RFS_TWAP"] = "RFS_TWAP";
})(OrderAlgorithmStrategy || (exports.OrderAlgorithmStrategy = OrderAlgorithmStrategy = {}));
var _default = OrderAlgorithmStrategy;
exports.default = _default;